import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("源单导入")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "选择材料清单", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("small", { class: "text-grey ml10" }, "选中仅对当前页有效", -1)

export function render(_ctx, _cache) {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_input_search = _resolveComponent("a-input-search")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_form = _resolveComponent("a-form")
  const _component_table_wrapper = _resolveComponent("table-wrapper")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_button, {
      loading: _ctx.loading,
      type: "primary",
      onClick: _ctx.showModal
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["loading", "onClick"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = $event => ((_ctx.visible) = $event)),
      width: "1000px",
      keyboard: false,
      centered: true,
      "mask-closable": false,
      onOk: _ctx.ok,
      onCancel: _ctx.closeModal
    }, {
      title: _withCtx(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_search, {
                  value: _ctx.queryRef.materialName,
                  "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.queryRef.materialName) = $event)),
                  valueModifiers: { trim: true },
                  placeholder: "请输入材料名称关键字",
                  style: {"width":"250px"},
                  "enter-button": "",
                  "allow-clear": "",
                  loading: _ctx.loading,
                  onSearch: _ctx.search
                }, null, 8, ["value", "loading", "onSearch"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_table_wrapper, {
          dataSource: _ctx.dataSource?.records,
          onOnSelectionChange: _ctx.onSelectionChange,
          tableHeight: 400,
          loading: _ctx.loading,
          columns: _ctx.columns
        }, {
          price: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_ctx.$filters.formatMoney(record.price)), 1)
          ]),
          totalPrice: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_ctx.$filters.formatMoney(record.totalPrice)), 1)
          ]),
          _: 1
        }, 8, ["dataSource", "onOnSelectionChange", "loading", "columns"])
      ]),
      _: 1
    }, 8, ["visible", "onOk", "onCancel"])
  ], 64))
}